import IndustrialProduct from "./components/IndustrialProduct";
import axios from "axios";
import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
function Nevera() {
  const [axial, setaxial] = useState([]);

  const [filtroSeleccionado, setFiltroSeleccionado] = useState("actuator");
  async function obtenerdatos() {
    const respuesta = await axios.get("https://gj-frio-industrial-api.onrender.com");
    setaxial(respuesta.data.axiales);
    console.log(respuesta.data);
  }
  useEffect(() => {
    obtenerdatos();
  }, []);
  return (
    <div style={{ backgroundColor: "#f4f7f8" }}>
      {/* Navbar ocupa todo el ancho */}
      <Navbar />
      <br></br>
      <br></br>
      <br></br>
      <h1 className="text-center text-primary">REFRIGERACIÓN DOMÉSTICA</h1>
      <br></br>

      <div className="container">
        <button
          className="btn text-light animated-button shadow-sm"
          style={{
            backgroundColor: "#fc580c",
            border: "none",
            borderRadius: "10px",
          }}
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasWithBothOptions"
          aria-controls="offcanvasWithBothOptions"
        >
          Click Aqui
          <i className="bi bi-chevron-double-right icon-move"></i>
        </button>

        <div
          class="offcanvas offcanvas-start"
          data-bs-scroll="true"
          tabindex="-1"
          id="offcanvasWithBothOptions"
          aria-labelledby="offcanvasWithBothOptionsLabel"
        >
          <div class="offcanvas-header">
            <h5
              class="offcanvas-title text-primary"
              id="offcanvasWithBothOptionsLabel"
            >
              Productos por subcategoria
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>
          <div class="offcanvas-body ">
            <div class="shadow-none p-3 mb-5 bg-light rounded ">
              <ul className="list-group border border-info ">
                <li
                  className="list-group-item list-group-item-action list-group-item-info"
                  onClick={() => setFiltroSeleccionado("actuator")}
                  style={{
                    cursor: "pointer",
                    fontWeight:
                      filtroSeleccionado === "actuator" ? "bold" : "normal",
                  }}
                >
                  Actuadores
                </li>
                <li
                  className="list-group-item list-group-item-action list-group-item-info"
                  onClick={() => setFiltroSeleccionado("manguera")}
                  style={{
                    cursor: "pointer",
                    fontWeight:
                      filtroSeleccionado === "manguera" ? "bold" : "normal",
                  }}
                >
                  Mangueras
                </li>
                <li
                  className="list-group-item list-group-item-action list-group-item-info"
                  onClick={() => setFiltroSeleccionado("selenoidelav")}
                  style={{
                    cursor: "pointer",
                    fontWeight:
                      filtroSeleccionado === "selenoidelav" ? "bold" : "normal",
                  }}
                >
                  Electroválvulas
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <br></br>
      <div className="container">
        <div className="row row-cols-1 row-cols-md-4 g-4">
          {/* {filtroSeleccionado === "manguera" &&
            productosMangueraFiltrados?.map((item) => (
            <IndustrialProduct
              key={item.nombre}
              img={item.imagen}
              title={item.nombre}
              id={item._id}
              details={[
                { label: "Marca", value: item.marca },
               
                { label: "Código Producto", value: item.codigoProducto },
                {
                  label: "Descripción",
                  value: item.descripcion,
                },
              ]}
            />
          ))}
          {filtroSeleccionado === "actuator" &&
            productosActuatorFiltrados?.map((item) => (
            <IndustrialProduct
              key={item.nombre}
              img={item.imagen}
              title={item.nombre}
              id={item._id}
              details={[
                { label: "Marca", value: item.marca },
                { label: "Modelo", value: item.modelo },
                { label: "Código Producto", value: item.codigoProducto },
                {
                  label: "Descripción",
                  value: item.descripcion,
                },
              ]}
            />
          ))}
           {filtroSeleccionado === "selenoidelav" &&
            productosSelenoidelavFiltrados?.map((item) => (
            <IndustrialProduct
              key={item.nombre}
              img={item.imagen}
              title={item.nombre}
              id={item._id}
              details={[
                { label: "Marca", value: item.marca },
                { label: "Modelo", value: item.modelo },
                { label: "Código Producto", value: item.codigoProducto },
                {
                  label: "Descripción",
                  value: item.descripcion,
                },
              ]}
            />
          ))} */}
        </div>
      </div>
      <br></br>
      <hr />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
export default Nevera;
